import {
    apiRequest,
    skpensiunDetail,
    skpensiunUpdate,
    masterRank,
    masterWorkUnit
} from "../../../../../services/adapters/kepegawaian/skpensiunService"

class UpdateRepository {

    fetchRank = async (query) => {
        return await apiRequest("get", masterRank, {
            params: query
        }, true)
    }

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", skpensiunDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", skpensiunUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository